import { render, staticRenderFns } from "./DateOfBirthNameAddressCityZipCodeEmailPhoneNumber.vue?vue&type=template&id=9079afd8&scoped=true&"
import script from "./DateOfBirthNameAddressCityZipCodeEmailPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./DateOfBirthNameAddressCityZipCodeEmailPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./DateOfBirthNameAddressCityZipCodeEmailPhoneNumber.vue?vue&type=style&index=0&id=9079afd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9079afd8",
  null
  
)

export default component.exports